export function isWalletSnapshotValue(value) {
    if (!isRecord(value) || !hasOnlyKeys(value, ["balanceMsat", "l402", "payments", "spendableMsat"]) ||
        !isNonNegativeNumber(value.balanceMsat) || !isNonNegativeNumber(value.spendableMsat))
        return false;
    return Array.isArray(value.payments) && value.payments.every(isWalletPaymentRecord) &&
        Array.isArray(value.l402) && value.l402.every(isWalletL402Receipt);
}
export function isWalletAuthoritativeSnapshot(value) {
    return isRecord(value) && hasOnlyKeys(value, ["observedAt", "staleAt", "value"]) &&
        typeof value.observedAt === "string" && typeof value.staleAt === "string" &&
        isWalletSnapshotValue(value.value);
}
export function isWalletCommandResult(value) {
    if (!isRecord(value) || !isNonNegativeNumber(value.amountMsat))
        return false;
    if (value.kind === "invoice-created") {
        return hasOnlyKeys(value, ["amountMsat", "invoiceId", "kind", "paymentHash", "paymentRequest", "status"]) &&
            value.status === "created" && typeof value.invoiceId === "string" && typeof value.paymentRequest === "string" &&
            (value.paymentHash === undefined || typeof value.paymentHash === "string");
    }
    return hasOnlyKeys(value, ["amountMsat", "kind", "paymentHash", "paymentId", "status"]) &&
        value.kind === "payment-submitted" &&
        (value.status === "pending" || value.status === "succeeded" || value.status === "failed") &&
        typeof value.paymentId === "string" &&
        (value.paymentHash === undefined || typeof value.paymentHash === "string");
}
function isWalletPaymentRecord(value) {
    if (!isRecord(value) || !isNonNegativeNumber(value.amountMsat) || typeof value.createdAt !== "string" ||
        typeof value.id !== "string" || typeof value.updatedAt !== "string" ||
        !hasOnlyKeys(value, ["amountMsat", "createdAt", "direction", "failureCode", "id", "paymentHash", "status", "updatedAt"]))
        return false;
    return (value.direction === "incoming" || value.direction === "outgoing") &&
        (value.status === "pending" || value.status === "succeeded" || value.status === "failed" || value.status === "expired") &&
        (value.failureCode === undefined || typeof value.failureCode === "string") &&
        (value.paymentHash === undefined || typeof value.paymentHash === "string");
}
function isWalletL402Receipt(value) {
    return isRecord(value) && hasOnlyKeys(value, ["amountMsat", "paidAt", "paymentHash", "receiptId", "resource"]) &&
        isNonNegativeNumber(value.amountMsat) && typeof value.paidAt === "string" &&
        typeof value.receiptId === "string" && typeof value.resource === "string" &&
        (value.paymentHash === undefined || typeof value.paymentHash === "string");
}
function isNonNegativeNumber(value) {
    return typeof value === "number" && Number.isFinite(value) && value >= 0;
}
function isRecord(value) {
    return value !== null && typeof value === "object" && !Array.isArray(value);
}
function hasOnlyKeys(value, allowed) {
    const allowedKeys = new Set(allowed);
    return Object.keys(value).every((key) => allowedKeys.has(key));
}
//# sourceMappingURL=wallet-mirror-repository.js.map